// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Api from "../app-core/Api.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as Cache from "../data/Cache.bs.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Route from "../Route.bs.js";
import * as React from "react";
import * as Router from "common/src/Router.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as LbUtils from "./LbUtils.bs.js";
import * as $$Promise from "common/src/Promise.bs.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as LbCustom from "./LbCustom.bs.js";
import * as LbRanked from "./LbRanked.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as StatsTable2 from "../components/StatsTable2.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as LbTypeSelect from "./LbTypeSelect.bs.js";
import * as LpChartUtils from "common/src/LpChartUtils.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as LbPlayerSearch from "./LbPlayerSearch.bs.js";
import * as PlayerBookmark from "../player/PlayerBookmark.bs.js";
import * as SnackbarService from "common/src/SnackbarService.bs.js";
import CopyToClipboard from "copy-to-clipboard";
import Menu from "@mui/material/Menu";
import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Share from "@mui/icons-material/Share";
import MoreVert from "@mui/icons-material/MoreVert";

var sub = {
  contents: undefined
};

var cols = Belt_Array.concat(LbRanked.cols, [StatsTable2.col(undefined, undefined, (function (param, param$1) {
              return null;
            }), undefined, (function (v, param, param$1) {
              return React.createElement("div", {
                          className: "flex items-center pr-2"
                        }, React.createElement(IconButton, {
                              onClick: (function (e) {
                                  var cb = sub.contents;
                                  if (cb !== undefined) {
                                    return Curry._3(cb, e.currentTarget, v.region, v.playerName);
                                  }
                                  
                                }),
                              size: "small",
                              children: React.createElement(MoreVert, {})
                            }));
            }), "pl-0 pr-0", undefined, undefined, undefined, undefined, 44, undefined, undefined)]);

function LbBookmarks(Props) {
  var t = Translation.useT(/* Common */0);
  var set = TftSet.use(undefined);
  var router = Router.use(undefined);
  var match = React.useState(function () {
        
      });
  var setMoreMenu = match[1];
  var moreMenu = match[0];
  var match$1 = React.useState(function () {
        return false;
      });
  var setCreateModalOpen = match$1[1];
  var createModalOpen = match$1[0];
  var match$2 = React.useState(function () {
        return "";
      });
  var setTitle = match$2[1];
  var title = match$2[0];
  React.useEffect((function () {
          sub.contents = (function (target, r, name) {
              return Curry._1(setMoreMenu, (function (param) {
                            return [
                                    target,
                                    r,
                                    name
                                  ];
                          }));
            });
          
        }), []);
  var match$3 = PlayerBookmark.use(undefined);
  var setBookmarks = match$3[1];
  var bookmarks = match$3[0];
  var data = Cache.useBookmarkLeaderboards(undefined);
  var data$1 = React.useMemo((function () {
          return Belt_Option.map(data, (function (param) {
                        return Belt_Array.mapWithIndex(Belt_SortArray.stableSortBy(param[0], (function (pl1, pl2) {
                                          return Caml.caml_int_compare(Belt_Option.mapWithDefault(pl2.rank, 0, (function (rank) {
                                                            return LpChartUtils.divisionToBase(rank[0], set) + rank[1] | 0;
                                                          })), Belt_Option.mapWithDefault(pl1.rank, 0, (function (rank) {
                                                            return LpChartUtils.divisionToBase(rank[0], set) + rank[1] | 0;
                                                          })));
                                        })), (function (idx, v) {
                                      return {
                                              num: idx,
                                              region: v.region,
                                              playerName: v.playerName,
                                              tag: v.tag,
                                              patch: v.patch,
                                              companionId: v.companionId,
                                              rank: v.rank,
                                              games: v.games,
                                              top4: v.top4,
                                              won: v.won,
                                              mostPlayedUnits: v.mostPlayedUnits,
                                              prePatchRank: v.prePatchRank,
                                              patchGames: v.patchGames,
                                              patchTop4: v.patchTop4,
                                              patchWon: v.patchWon,
                                              patchMostPlayedUnits: v.patchMostPlayedUnits
                                            };
                                    }));
                      }));
        }), [data]);
  var match$4 = React.useState(function () {
        return false;
      });
  var usePatchStats = match$4[0];
  var renderElements = LbUtils.useRenderElements(undefined);
  var data$2 = React.useMemo((function () {
          return Belt_Option.map(data$1, (function (data) {
                        return Belt_Array.slice(data, 0, renderElements);
                      }));
        }), [
        renderElements,
        data$1
      ]);
  var keyFn = React.useCallback((function (d) {
          return d.region + " " + d.playerName;
        }), []);
  return React.createElement(AdLayout.make, {
              children: null
            }, React.createElement("div", {
                  className: "flex flex-col items-center"
                }, React.createElement(LbPlayerSearch.make, {}), React.createElement(LbTypeSelect.make, {
                      region: undefined,
                      typ: /* Bookmarks */4
                    }), React.createElement(ContentSection.make, {
                      className: "font-montserrat font-medium md:w-[940px]",
                      children: data$2 !== undefined && data$2.length !== 0 ? React.createElement(React.Fragment, undefined, React.createElement("div", {
                                  className: "flex justify-end pt-4 px-4"
                                }, React.createElement(Button, {
                                      startIcon: React.createElement(Share, {}),
                                      onClick: (function (param) {
                                          return Curry._1(setCreateModalOpen, (function (param) {
                                                        return true;
                                                      }));
                                        }),
                                      variant: "outlined",
                                      color: "primary",
                                      size: "small",
                                      children: t("Share")
                                    })), React.createElement("div", {
                                  className: usePatchStats ? "lb-patch-stats" : "lb-season-stats"
                                }, React.createElement(StatsTable2.make, {
                                      montserratHeader: true,
                                      size: "lg",
                                      cols: cols,
                                      data: data$2,
                                      context: undefined,
                                      extraStickyHeader: React.createElement("div", {
                                            className: "h-10 flex items-center justify-between pt-1 pr-6 text-center font-semibold"
                                          }, React.createElement("div", undefined), React.createElement(LbUtils.PatchStatsToggle.make, {
                                                usePatchStats: usePatchStats,
                                                setUsePatchStats: match$4[1]
                                              })),
                                      keyFn: keyFn,
                                      stickyColCount: 2,
                                      top: "t48"
                                    }))) : null,
                      noPadding: true
                    })), React.createElement(Menu, {
                  open: Belt_Option.isSome(moreMenu),
                  onClose: (function (param) {
                      return Curry._1(setMoreMenu, (function (param) {
                                    
                                  }));
                    }),
                  anchorEl: Belt_Option.map(moreMenu, (function (param) {
                          return param[0];
                        })),
                  children: React.createElement(MenuItem, {
                        onClick: (function (param) {
                            if (moreMenu !== undefined) {
                              var playerName = moreMenu[2];
                              var region = moreMenu[1];
                              Curry._1(setBookmarks, (function (bookmarks) {
                                      return Belt_Array.keep(bookmarks, (function (bm) {
                                                    if (bm.region !== region) {
                                                      return true;
                                                    } else {
                                                      return bm.name !== playerName;
                                                    }
                                                  }));
                                    }));
                              var cb = SnackbarService.sub.contents;
                              if (cb !== undefined) {
                                Curry._1(cb, "Removed from bookmarks. Please refresh the page.");
                              }
                              
                            } else {
                              var cb$1 = SnackbarService.sub.contents;
                              if (cb$1 !== undefined) {
                                Curry._1(cb$1, "Something went wrong.");
                              }
                              
                            }
                            return Curry._1(setMoreMenu, (function (param) {
                                          
                                        }));
                          }),
                        children: "Remove Bookmark"
                      })
                }), React.createElement(Modal, {
                  BackdropProps: {
                    className: CssJs.style([CssJs.important(CssJs.backgroundColor(CssJs.rgba(0, 0, 0, {
                                        NAME: "num",
                                        VAL: 0.6
                                      })))])
                  },
                  open: createModalOpen,
                  onClose: (function (param) {
                      return Curry._1(setCreateModalOpen, (function (param) {
                                    return false;
                                  }));
                    }),
                  children: React.createElement("div", {
                        className: CssJs.style([
                              CssJs.outline(CssJs.px(0), CssJs.solid, CssJs.transparent),
                              CssJs.position(CssJs.absolute),
                              CssJs.left(CssJs.pct(50)),
                              CssJs.top(CssJs.pct(50)),
                              CssJs.transform(CssJs.translate(CssJs.pct(-50), CssJs.pct(-50)))
                            ])
                      }, React.createElement(Paper, {
                            children: createModalOpen ? React.createElement("div", {
                                    className: "p-6 flex items-end gap-4"
                                  }, React.createElement(TextField, {
                                        autoFocus: true,
                                        label: "Title",
                                        value: title,
                                        onChange: (function (e) {
                                            var v = e.target.value;
                                            return Curry._1(setTitle, (function (param) {
                                                          return v;
                                                        }));
                                          }),
                                        variant: "standard"
                                      }), React.createElement(Button, {
                                        onClick: (function (param) {
                                            if (title === "") {
                                              return ;
                                            }
                                            Curry._1(setCreateModalOpen, (function (param) {
                                                    return false;
                                                  }));
                                            var summoners = Belt_Array.map(bookmarks, PlayerBookmark.encode);
                                            return $$Promise.consume(Api.createBookmarkLeaderboards(title, summoners), (function (key) {
                                                          var url = Route.toString({
                                                                TAG: /* Leaderboards */7,
                                                                _0: {
                                                                  TAG: /* Custom */4,
                                                                  _0: key
                                                                }
                                                              });
                                                          CopyToClipboard(url);
                                                          var cb = SnackbarService.sub.contents;
                                                          if (cb !== undefined) {
                                                            Curry._1(cb, "Link copied to clipboard");
                                                          }
                                                          LbCustom.init.contents = url;
                                                          return router.push(url, undefined, undefined);
                                                        }));
                                          }),
                                        variant: "contained",
                                        color: "secondary",
                                        size: "small",
                                        children: "Create"
                                      })) : null
                          }))
                }));
}

var make = LbBookmarks;

export {
  sub ,
  cols ,
  make ,
  
}
/* cols Not a pure module */
